// Stepper — the horizontal "1 ─ 2 ─ 3" progress header used by multi-step flows
// (bulk employee import, the Learning ProgramWizard, …). Presentational only:
// the caller owns the current index and passes already-translated labels.
// Completed steps show a check, the current step is highlighted, later steps
// are muted. Extracted from BulkImportPage so every wizard shares one look.
import React from 'react';

export interface StepperProps {
  /** Translated step labels, in order. */
  steps: string[];
  /** Zero-based index of the active step. */
  current: number;
  className?: string;
}

export const Stepper: React.FC<StepperProps> = ({ steps, current, className }) => (
  <ol className={`flex items-center gap-2 ${className || ''}`} aria-label="Progress">
    {steps.map((label, i) => (
      <React.Fragment key={`${i}-${label}`}>
        <li className="flex items-center gap-2" aria-current={i === current ? 'step' : undefined}>
          <span
            className={`inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold ${
              i <= current ? 'bg-orange-500 text-white' : 'bg-muted text-muted-foreground'
            }`}
            aria-hidden
          >
            {i < current ? '✓' : i + 1}
          </span>
          <span className={`text-sm ${i === current ? 'text-foreground font-medium' : 'text-muted-foreground'}`}>
            {label}
          </span>
        </li>
        {i < steps.length - 1 && <li className="flex-1 h-px bg-border min-w-[16px]" aria-hidden />}
      </React.Fragment>
    ))}
  </ol>
);

export default Stepper;
